import { Box, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import React, { Fragment } from 'react'
import { useQuery } from 'react-query'
import { channelGetInfo } from '../../utils/api'
import moment from 'moment'
import { formatPrice } from '../../utils'

const Home = () => {

    const { data } = useQuery<{ channelInfo: SalesChannel, users: ChannelUser[], reports: ChannelSalesReport[] }>('channelGetInfo', () => channelGetInfo())

    return <Box p={2}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
                <Paper>
                    <Box p={1.5}>
                        <Typography>渠道信息</Typography>
                    </Box>
                    <Box p={1.5}>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">渠道ID</Typography>
                            <Typography variant="body2">{data?.channelInfo.channel_id}</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">渠道名称</Typography>
                            <Typography variant="body2">{data?.channelInfo.display_name}</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">手机号</Typography>
                            <Typography variant="body2">{data?.channelInfo.mobile}</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">新用户赠送爱豆</Typography>
                            <Typography variant="body2">{data?.channelInfo.present_coin}爱豆</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">用户累计消费总额</Typography>
                            <Typography variant="body2">{formatPrice(data?.channelInfo.sales)}元</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">累计实际到账（估算）</Typography>
                            <Typography variant="body2">{formatPrice(data?.channelInfo.income)}元</Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">渠道二维码</Typography>
                            <Typography variant="body2"></Typography>
                        </Box>
                        <Box p={1} display="flex" justifyContent="space-between">
                            <img width="100%" height="100%" src={data?.channelInfo.qrcode} />
                        </Box>
                    </Box>
                </Paper>
            </Grid>
            <Grid item container xs={12} sm={6} md={6}>


                <Grid item xs={12} >
                    <Paper>
                        <Box p={1.5}>
                            <Typography>月度统计</Typography>
                        </Box>
                        <Box>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>月份</TableCell>
                                            <TableCell align="center">用户累计消费总额</TableCell>
                                            <TableCell align="center">累计实际到账（估算）</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.reports.map(r => <TableRow>
                                            <TableCell>{r.month}</TableCell>
                                            <TableCell align="center"> {formatPrice(r.sales)}元</TableCell>
                                            <TableCell align="center">{formatPrice(r.income)}元</TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} style={{marginTop: '16px'}} >
                    <Paper>
                        <Box p={1.5}>
                            <Typography>用户列表</Typography>
                        </Box>
                        <Box>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>手机号</TableCell>
                                            <TableCell align="center">注册时间</TableCell>
                                            <TableCell align="center">用户累计消费总额</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.users.map(user => <TableRow>
                                            <TableCell>{`${user.mobile}`}</TableCell>
                                            <TableCell align="center"> {user.signup_time ? moment(user.signup_time).format('YYYY-MM-DD HH:mm') : ''}</TableCell>
                                            <TableCell align="center">{formatPrice(+user.amount)}元</TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    </Box >
}

export default Home